module.exports = __webpack_public_path__ + "img/login_bsgs_left.c4ddfee9.jpg";